<app-cardholder-details
  *ngIf="cardholder"
  [cardholder]="cardholder"
  (newCardholderSelected)="showNewCardholder($event)">
</app-cardholder-details>

<form name="cardholdersLocationForm"
      *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_LOCATION')"
      [formGroup]="cardholdersLocationForm"
      novalidate>

  <div class="card card-nc">
    <div class="card-heading ">
      <span class="icon-NC_location"></span>
      <span class="panelHeaderHeading"> LOCATION </span>&nbsp;&nbsp;
      <span class="pull-right save-panel">
        <button *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_LOCATION_UPDATE') && !isEscrow"
                type="submit"
                [disabled]="save_location_btn"
                (click)="saveLocation()"
                class="btn btn-nc save-panel-btn">
          SAVE
          <i [ngClass]="save_location_btn_spinner"></i>
        </button>
      </span>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-4 zeroPadding">
          <label for="location" class="col-md-12 control-label labelCommon">Location</label>
          <div class="form-group col-md-10"
               *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_LOCATION_UPDATE') && !isEscrow">
            <select class="form-control input-sm"
                    id="location"
                    formControlName="location"
                    [(ngModel)]="shipLoc"
                    (change)="changeMeu($event)">
              <option *ngFor="let profile of profiles" [value]="profile.shipLocation">
                {{profile.shipName + ' (' + profile.shipLocation + ')'}}
              </option>
            </select>
          </div>
          <div class="form-group col-md-10 staticText1"
               *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_LOCATION_UPDATE') || isEscrow">
            {{identity?.currentShip?.shipName}}({{identity?.currentShip?.shipLocation}})
          </div>
        </div>
        <div class="form-group col-md-4 zeroPadding" *ngIf="identity && identity.militaryBranch =='MARINES'">
          <label for="meu" class="col-md-12 control-label labelCommon">MEU</label>
          <div class="form-group col-md-10"
               *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_LOCATION_UPDATE') && identity.militaryBranch =='MARINES' && !isEscrow">
            <select class="form-control input-sm"
                    formControlName="meu"
                    id="meu">
              <option *ngFor="let meu of filterMeus(shipLoc)" value="{{ meu }}">{{meu}}</option>
            </select>
          </div>
          <div class="form-group col-md-10 staticText1"
               *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_LOCATION_UPDATE') && identity.militaryBranch =='MARINES'">
            {{identity.meu}}
          </div>
        </div>
      </div>
    </div>
  </div>

</form>

<form name="cardholderPersonalInfoForm"
      [formGroup]="cardholderPersonalInfoForm"
      *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO')"
      novalidate>

  <div class="card card-nc">
    <div class="card-heading">
      <i class="fa fa-user"></i>
      <span class="panelHeaderHeading"> PERSONAL INFORMATION </span>&nbsp;&nbsp;
      <span class="pull-right save-panel">
        <button *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_UPDATE') && !isEscrow"
                type="submit"
                [disabled]="save_btn"
                (click)="savePersonalInfo()"
                class="btn btn-nc save-panel-btn">
          SAVE
          <i [ngClass]="save_btn_spinner"></i>
        </button>
      </span>
    </div>
    <div class="card-body">
      <div *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_PII') && identity && cardholderPersonalInfo">
        <div class="row">
          <div class="col-md-4 zeroPadding">
            <label for="payGrade" class="col-md-12 control-label labelCommon"> Pay Grade
              <span class="text-danger" *ngIf="cardholder?.enrollmentType !== 'C' && cardholder?.enrollmentType !== 'F' && cardholder?.enrollmentType !== 'M'">*</span></label>
            <div class="form-group col-md-10">
              <select *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_PII_UPDATE') && !isEscrow"
                      class="form-control input-sm"
                      id="payGrade"
                      formControlName="payGrade">
                <option *ngFor="let payGrade of cardholderPersonalInfo.payGrades"
                        value="{{payGrade}}">{{payGrade}}</option>
              </select>
              <span class="help-block has-error validationMessage"
                    *ngIf="!cardholderPersonalInfoForm.get('payGrade').valid &&
                          cardholderPersonalInfoForm.get('payGrade').touched">
                <span *ngIf="cardholderPersonalInfoForm.get('payGrade').errors?.required">
                   Required
                </span>
              </span>
              <span class="staticText1" *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_PII_UPDATE') || isEscrow">
                {{identity.payGrade}}
              </span>
            </div>
          </div>
          <div class="col-md-4 zeroPadding">
            <label for="militaryBranch" class="col-md-12 control-label labelCommon">
              Military Branch <span class="text-danger" *ngIf="cardholder?.enrollmentType !== 'C' && cardholder?.enrollmentType !== 'F' && cardholder?.enrollmentType !== 'M'">*</span>
            </label>
            <div class="form-group col-md-10">
              <select *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_PII_UPDATE') && !isEscrow"
                      class="form-control input-sm"
                      id="militaryBranch"
                      formControlName="militaryBranch">
                <option *ngFor="let militaryBranch of cardholderPersonalInfo.militaryBranches"
                        value="{{militaryBranch}}">
                  {{militaryBranch}}
                </option>
              </select>
              <span class="help-block has-error validationMessage"
                    *ngIf="!cardholderPersonalInfoForm.get('militaryBranch').valid &&
                          cardholderPersonalInfoForm.get('militaryBranch').touched">
                <span *ngIf="cardholderPersonalInfoForm.get('militaryBranch').errors?.required">
                   Required
                </span>
              </span>
              <span class="staticText1" *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_PII_UPDATE') || isEscrow">
                {{identity.militaryBranch}}
              </span>
            </div>
          </div>
          <div class="col-md-4 zeroPadding">
            <label class="col-md-12 control-label">&nbsp;</label>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 zeroPadding">
            <label for="firstName" class="col-md-12 control-label labelCommon">
              First Name <span class="text-danger" *ngIf="cardholder?.enrollmentType !== 'C' && cardholder?.enrollmentType !== 'F' && cardholder?.enrollmentType !== 'M'">*</span>
            </label>
            <div class="form-group col-md-10">
              <input *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_PII_UPDATE') && !isEscrow"
                     type="text"
                     class="form-control input-sm"
                     id="firstName"
                     formControlName="firstName"/>
              <span class="help-block has-error validationMessage"
                    *ngIf="!cardholderPersonalInfoForm.get('firstName').valid &&
                          cardholderPersonalInfoForm.get('firstName').touched">
                <span *ngIf="cardholderPersonalInfoForm.get('firstName').errors['invalidCardHolderName']">
                    Only alphabets,space and - are allowed
                </span>
                <span *ngIf="cardholderPersonalInfoForm.get('firstName').errors?.required">
                   Required
                </span>
                <span *ngIf="cardholderPersonalInfoForm.get('firstName').errors?.maxlength">
                   Name can only be 30 characters
                </span>
              </span>
              <span class="staticText1"
                    *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_PII_UPDATE') || isEscrow">
                {{identity.firstName}}
              </span>
            </div>
          </div>
          <div class="col-md-4 zeroPadding">
            <label for="lastName" class="col-md-12 control-label labelCommon"> Last Name <span class="text-danger" *ngIf="cardholder?.enrollmentType !== 'C' && cardholder?.enrollmentType !== 'F' && cardholder?.enrollmentType !== 'M'">*</span></label>
            <div class="form-group col-md-10">
              <input *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_PII_UPDATE') && !isEscrow"
                     type="text"
                     class="form-control input-sm"
                     id="lastName"
                     formControlName="lastName"/>
              <span class="help-block has-error validationMessage"
                    *ngIf="!cardholderPersonalInfoForm.get('lastName').valid &&
                          cardholderPersonalInfoForm.get('lastName').touched">
                <span *ngIf="cardholderPersonalInfoForm.get('lastName').errors['invalidCardHolderName']">
                    Only alphabets,space and - are allowed
                </span>
                <span *ngIf="cardholderPersonalInfoForm.get('lastName').errors?.required">
                   Required
                </span>
                <span *ngIf="cardholderPersonalInfoForm.get('lastName').errors?.maxlength">
                   Name can only be 30 characters
                </span>
              </span>
              <span class="staticText1"
                    *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_PII_UPDATE') || isEscrow">
                {{identity.lastName}}
              </span>
            </div>
          </div>
          <div class="col-md-4 zeroPadding">
            <label for="middleName" class="col-md-12 control-label labelCommon"> Middle Name </label>
            <div class="form-group col-md-10">
              <input *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_PII_UPDATE') && !isEscrow"
                     type="text"
                     class="form-control input-sm"
                     id="middleName"
                     formControlName="middleName"/>
              <span class="help-block has-error validationMessage"
                    *ngIf="!cardholderPersonalInfoForm.get('middleName').valid &&
                          cardholderPersonalInfoForm.get('middleName').touched">
                <span *ngIf="cardholderPersonalInfoForm.get('middleName').errors['invalidCardHolderName']">
                    Only alphabets,space and - are allowed
                </span>
                <span *ngIf="cardholderPersonalInfoForm.get('middleName').errors?.required">
                   Required
                </span>
                <span *ngIf="cardholderPersonalInfoForm.get('middleName').errors?.maxlength">
                   Name can only be 30 characters
                </span>
              </span>
              <span class="staticText1"
                    *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_PII_UPDATE') || isEscrow">
                {{identity.middleName}}
              </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 zeroPadding">
            <label for="dob" class="col-md-12 control-label labelCommon"> Birth Date MM/DD/YYYY <span class="text-danger" *ngIf="cardholder?.enrollmentType !== 'C' && cardholder?.enrollmentType !== 'F' && cardholder?.enrollmentType !== 'M'">*</span></label>
            <div class="form-group col-md-10">
              <input *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_PII_UPDATE') && !isEscrow"
                     type="text"
                     class="form-control input-sm"
                     id="dob"
                     formControlName="dob"
                     maxlength="10"
                     placeholder="MM/DD/YYYY"/>
              <span class="staticText1"
                    *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_PII_UPDATE') || isEscrow">
                {{cardholderPersonalInfo?.dateOfBirth}}
              </span>
              <span class="help-block has-error validationMessage"
                    *ngIf="!cardholderPersonalInfoForm.get('dob').valid &&
                          cardholderPersonalInfoForm.get('dob').touched">
                    {{ dobErrorMessage }}
              </span>
              <span class="help-block has-error validationMessage"
                    *ngIf="!cardholderPersonalInfoForm.get('dob').valid &&
                          cardholderPersonalInfoForm.get('dob').touched">
                    {{ dobErrorMessage }}

                <span *ngIf="cardholderPersonalInfoForm.get('dob').errors?.required">
                 Required
              </span>
            </span>
            </div>
          </div>
          <div class="col-md-4 zeroPadding">
            <label for="mothersMaidenName" class="col-md-12 control-label labelCommon">
              Mother's Maiden Name or Security Keyword <span class="text-danger" *ngIf="cardholder?.enrollmentType !== 'C' && cardholder?.enrollmentType !== 'F' && cardholder?.enrollmentType !== 'M'">*</span>
            </label>
            <div class="form-group col-md-10">
              <input *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_PII_UPDATE') && !isEscrow"
                     type="text"
                     class="form-control input-sm"
                     id="mothersMaidenName"
                     formControlName="mothersMaidenName"/>
              <span class="help-block has-error validationMessage"
                    *ngIf="!cardholderPersonalInfoForm.get('mothersMaidenName').valid &&
                          cardholderPersonalInfoForm.get('mothersMaidenName').touched">
                <span *ngIf="cardholderPersonalInfoForm.get('mothersMaidenName').errors['invalidCardHolderName']">
                    Only alphabets,space and - are allowed
                </span>
                <span *ngIf="cardholderPersonalInfoForm.get('mothersMaidenName').errors?.required">
                   Required
                </span>
                <span *ngIf="cardholderPersonalInfoForm.get('mothersMaidenName').errors?.maxlength">
                   Name can only be 30 characters
                </span>
              </span>
              <span class="staticText1"
                    *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_PII_UPDATE') || isEscrow">
                {{identity.mothersMaidenName}}
              </span>
            </div>
          </div>
          <div class="col-md-4 zeroPadding">
            <label for="socialSecurity" class="col-md-12 control-label labelCommon"> SSN <span class="text-danger" *ngIf="cardholder?.enrollmentType !== 'C' && cardholder?.enrollmentType !== 'F' && cardholder?.enrollmentType !== 'M'">*</span></label>
            <div class="form-group col-md-10">
              <input *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_PII_UPDATE') && !isEscrow"
                     type="text"
                     class="form-control input-sm"
                     id="socialSecurity"
                     placeholder="{{identity.socialSecurity}}"
                     formControlName="socialSecurity"/>
              <span class="staticText1"
                    *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_PII_UPDATE') || isEscrow">
                {{identity.socialSecurity | last4digits}}
              </span>
              <span class="help-block has-error validationMessage">
                <span
                  *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_PII_UPDATE') && cardholderPersonalInfoForm.get('socialSecurity').errors?.pattern">
                  Invalid
                </span>
              </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 zeroPadding">
            <label for="primaryEmail" class="col-md-12 control-label labelCommon">Primary Email <span class="text-danger" *ngIf="cardholder?.enrollmentType !== 'C' && cardholder?.enrollmentType !== 'F' && cardholder?.enrollmentType !== 'M'">*</span></label>
            <div class="form-group col-md-10">
              <input *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_CONTACT_UPDATE') && !isEscrow"
                     type="email"
                     class="form-control input-sm"
                     id="primaryEmail"
                     formControlName="primaryEmail"
                     maxlength="50"/>
              <span class="staticText1"
                    *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_CONTACT_UPDATE') || isEscrow">
                {{cardholderPersonalInfo.primaryEmail.emailAddr}}
              </span>
              <span class="help-block has-error validationMessage"
                    *ngIf="!cardholderPersonalInfoForm.get('primaryEmail').valid &&
                                        cardholderPersonalInfoForm.get('primaryEmail').touched">
                <span
                  *ngIf="cardholderPersonalInfoForm.get('primaryEmail').errors?.email">
                  Invalid
                </span>
                <span *ngIf="cardholderPersonalInfoForm.get('primaryEmail').errors?.required">
                   Required
                </span>
              </span>
            </div>
          </div>
          <div class="col-md-4 zeroPadding">
            <label for="secondaryEmail" class="col-md-12 control-label labelCommon">Secondary Email <span class="text-danger" *ngIf="cardholder?.enrollmentType !== 'C' && cardholder?.enrollmentType !== 'F' && cardholder?.enrollmentType !== 'M'">*</span></label>
            <div class="form-group col-md-10">
              <input *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_CONTACT_UPDATE') && !isEscrow"
                     type="email"
                     class="form-control input-sm"
                     id="secondaryEmail"
                     formControlName="secondaryEmail"
                     maxlength="50"/>
              <span class="staticText1"
                    *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_CONTACT_UPDATE') || isEscrow">
                {{cardholderPersonalInfo.secondaryEmail.emailAddr}}
              </span>
              <span class="help-block has-error validationMessage"
                    *ngIf="!cardholderPersonalInfoForm.get('secondaryEmail').valid &&
                                                      cardholderPersonalInfoForm.get('secondaryEmail').touched">
                <span *ngIf="cardholderPersonalInfoForm.get('secondaryEmail').errors?.email">
                  Invalid
                </span>
                <span *ngIf="cardholderPersonalInfoForm.get('secondaryEmail').errors?.required">
                   Required
                </span>
              </span>
            </div>
          </div>
          <div class="col-md-4 zeroPadding">
            <label class="col-md-12 control-label">&nbsp;</label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 zeroPadding">
            <label for="dayPhone" class="col-md-12 control-label labelCommon">Work Phone </label>
            <div class="form-group col-md-10">
              <input *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_CONTACT_UPDATE') && !isEscrow"
                     type="text"
                     class="form-control input-sm"
                     id="dayPhone"
                     formControlName="dayPhone"
                     maxlength="25"/>
              <span class="help-block has-error validationMessage"
                    *ngIf="!cardholderPersonalInfoForm.get('dayPhone').valid &&
                          cardholderPersonalInfoForm.get('dayPhone').touched">
                <span *ngIf="cardholderPersonalInfoForm.get('dayPhone').errors?.pattern">
                    Invalid Phone Number
                </span>
              </span>
              <span class="staticText1"
                    *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_CONTACT_UPDATE') || isEscrow">
                {{cardholderPersonalInfo.userPhone.dayPhone}}
              </span>
            </div>
          </div>
          <div class="col-md-4 zeroPadding">
            <label for="evePhone" class="col-md-12 control-label labelCommon">Personal Phone <span class="text-danger" *ngIf="cardholder?.enrollmentType !== 'C' && cardholder?.enrollmentType !== 'F' && cardholder?.enrollmentType !== 'M'">*</span></label>
            <div class="form-group col-md-10">
              <input *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_CONTACT_UPDATE') && !isEscrow"
                     type="text"
                     class="form-control input-sm"
                     id="evePhone"
                     formControlName="evePhone"
                     maxlength="25"/>
              <span class="help-block has-error validationMessage"
                    *ngIf="!cardholderPersonalInfoForm.get('evePhone').valid &&
                          cardholderPersonalInfoForm.get('evePhone').touched">
                <span *ngIf="cardholderPersonalInfoForm.get('evePhone').errors?.pattern">
                    Invalid Phone Number
                </span>
                <span *ngIf="cardholderPersonalInfoForm.get('evePhone').errors?.required">
                   Required
                </span>
              </span>
              <span class="staticText1"
                    *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_CONTACT_UPDATE') || isEscrow">
                {{cardholderPersonalInfo.userPhone.evePhone}}
              </span>
            </div>
          </div>
          <div class="col-md-4 zeroPadding">
            <label class="col-md-12 control-label">&nbsp;</label>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6 zeroPadding" *ngIf="identity">
            <div *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ENROLLMENT_FORM') && identity.formSeq > 0"
                 class="col-md-6 hyperlink">
              <a (click)="showEnrollmentForm()">View ENROLLMENT Form</a>
            </div>
            <div
              *ngIf="(hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ENROLLMENT_FORM')) && !(identity.formSeq > 0)"
              class="col-md-6">
              <span>ENROLLMENT Form is not Available.</span>
            </div>
          </div>
        </div>
        <!-- ROB Form Start -->
        <!-- Removing the following section as robFormSeq is not currently part of the identity object -->
        <!--      <div class="row" *ngIf="hasEntitlements('TODO_ROB_FORM')">-->
        <!--        <div class="form-group col-md-6 zeroPadding">-->
        <!--          <div *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ENROLLMENT_FORM') && (identity.robFormSeq > 0)"-->
        <!--               class="col-md-10">-->
        <!--            <a (click)="showROBFormFile()">View RULES OF BEHAVIOR Form</a>-->
        <!--          </div>-->
        <!--          <div *ngIf="(hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ENROLLMENT_FORM')) && (identity.robFormSeq < 0)"-->
        <!--               class="col-md-6">-->
        <!--            <span> ROB Form is not Available.</span>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </div>-->
        <!-- ROB Form End -->
        <!-- The following was commented out in the legacy code.  Keeping until we determine if it is needed
      <div class="row">
        <div class="form-group col-md-6 zeroPadding">
          <div class="col-md-10">
            <a *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ENROLLMENT_FORM') && identity.formSeq > 0"
                (click)="showEnrollmentForm()">Enrollment Form Available in NavyCash
            </a>
            <span *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ENROLLMENT_FORM') && identity.formSeq > 0"
                  class="staticText3">Enrollment Form Available in NavyCash
            </span>
            <span class="staticText3" *ngIf="!(identity.formSeq > 0)" >{{identity.formStatus}}</span>
          </div>
        </div>
      </div>
      -->
        <!-- Residence/Permanent address information -->
        <div *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS')">
          <div class="borderLine"></div>
          <div class="row">
            <div class="col-md-12 zeroPadding">
              <label for="addressLine1" class="col-md-12 control-label labelCommon text-nowrap">
                Residence/Permanent Address <span class="text-danger" *ngIf="cardholder?.enrollmentType !== 'C' && cardholder?.enrollmentType !== 'F' && cardholder?.enrollmentType !== 'M'">*</span>
              </label>
              <div class="form-group col-md-12">
                <input placeholder="Address Line 1"
                       *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') && !isEscrow"
                       type="text"
                       class="form-control input-sm"
                       id="addressLine1"
                       formControlName="addressLine1"
                       maxlength="34"/>
                <span class="help-block has-error validationMessage"
                      *ngIf="!cardholderPersonalInfoForm.get('addressLine1').valid &&
                          cardholderPersonalInfoForm.get('addressLine1').touched">
                <span *ngIf="cardholderPersonalInfoForm.get('addressLine1').errors?.required">
                    Required
                </span>
              </span>
                <span class="staticText1"
                      *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') || isEscrow">
                {{cardholderPersonalInfo?.address?.addressLine1}}
              </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <input placeholder="Address Line 2"
                     *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') && !isEscrow"
                     type="text"
                     class="form-control input-sm"
                     id="addressLine2"
                     formControlName="addressLine2"
                     maxlength="34"/>
              <span class="staticText1"
                    *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') || isEscrow">
              {{cardholderPersonalInfo?.address?.addressLine2}}
            </span>
            </div>
            <div class="form-group col-md-6">
              <input placeholder="Address Line 3"
                     *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') && !isEscrow"
                     type="text"
                     class="form-control input-sm"
                     id="addressLine3"
                     formControlName="addressLine3"
                     maxlength="34"/>
              <span class="staticText1"
                    *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') || isEscrow">
              {{cardholderPersonalInfo?.address?.addressLine3}}
            </span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 zeroPadding">
              <label for="city" class="col-md-12 control-label labelCommon"> City <span class="text-danger" *ngIf="cardholder?.enrollmentType !== 'C' && cardholder?.enrollmentType !== 'F' && cardholder?.enrollmentType !== 'M'">*</span></label>
              <div class="col-md-10">
                <input *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') && !isEscrow"
                       type="text"
                       class="form-control input-sm"
                       id="city"
                       formControlName="city"
                       maxlength="34"/>
                <span class="help-block has-error validationMessage"
                      *ngIf="!cardholderPersonalInfoForm.get('city').valid &&
                          cardholderPersonalInfoForm.get('city').touched">
                <span *ngIf="cardholderPersonalInfoForm.get('city').errors['invalidCity']">
                    {{ contactCityErrorMessage }}
                </span>
                <span *ngIf="cardholderPersonalInfoForm.get('city').errors?.required">
                   Required
                </span>
                <span *ngIf="cardholderPersonalInfoForm.get('city').errors?.maxlength">
                   City can only be 34 characters
                </span>
              </span>
                <span class="staticText1"
                      *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') || isEscrow">
                {{cardholderPersonalInfo?.address?.city}}
              </span>
              </div>
            </div>
            <div class="col-md-2 zeroPadding">
              <label for="state" class="col-md-12 control-label labelCommon"> State <span class="text-danger" *ngIf="cardholder?.enrollmentType !== 'C' && cardholder?.enrollmentType !== 'F' && cardholder?.enrollmentType !== 'M'">*</span></label>
              <div class="col-md-10">
                <select
                  *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') && cardholderPersonalInfo && !isEscrow"
                  class="form-control input-sm"
                  id="state"
                  formControlName="state">
                  <option *ngFor="let state of cardholderPersonalInfo.states" value="{{state}}">{{state}}</option>
                </select>
                <span class="help-block has-error validationMessage"
                      *ngIf="!cardholderPersonalInfoForm.get('state').valid &&
                          cardholderPersonalInfoForm.get('state').touched">
                <span *ngIf="cardholderPersonalInfoForm.get('state').errors?.required">
                   Required
                </span>
              </span>
                <span class="staticText1"
                      *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') || isEscrow">
                {{cardholderPersonalInfo?.address?.state}}
              </span>
              </div>
            </div>
            <div class="col-md-2 zeroPadding">
              <label for="zip" class="col-md-12 control-label labelCommon"> Zip <span class="text-danger" *ngIf="cardholder?.enrollmentType !== 'C' && cardholder?.enrollmentType !== 'F' && cardholder?.enrollmentType !== 'M'">*</span></label>
              <div class="col-md-10">
                <input *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') && !isEscrow"
                       type="text"
                       class="form-control input-sm"
                       id="zip"
                       formControlName="zip"
                       maxlength="10"/>
                <span class="help-block has-error validationMessage"
                      *ngIf="!cardholderPersonalInfoForm.get('zip').valid &&
                          cardholderPersonalInfoForm.get('zip').touched">
                <span *ngIf="cardholderPersonalInfoForm.get('zip').errors['invalidZip']">
                    {{ contactZipErrorMessage }}
                </span>
                <span *ngIf="cardholderPersonalInfoForm.get('zip').errors?.required">
                   Required
                </span>
                <span *ngIf="cardholderPersonalInfoForm.get('zip').errors?.maxlength">
                   Zip can only be 10 characters
                </span>
              </span>
                <span class="staticText1"
                      *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') || isEscrow">
                {{cardholderPersonalInfo?.address?.zip}}
              </span>
              </div>
            </div>
            <div class="col-md-2 zeroPadding">
              <label for="country" class="col-md-12 control-label labelCommon"> Country <span class="text-danger" *ngIf="cardholder?.enrollmentType !== 'C' && cardholder?.enrollmentType !== 'F' && cardholder?.enrollmentType !== 'M'">*</span></label>
              <div class="col-md-10">
                <select
                  *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') && cardholderPersonalInfo && !isEscrow"
                  class="form-control input-sm"
                  id="country"
                  formControlName="country">
                  <option *ngFor="let country of countries" value="{{country}}">{{country}}</option>
                </select>
                <span class="help-block has-error validationMessage"
                      *ngIf="!cardholderPersonalInfoForm.get('country').valid &&
                          cardholderPersonalInfoForm.get('country').touched">
                <span *ngIf="cardholderPersonalInfoForm.get('country').errors?.required">
                   Required
                </span>
              </span>
                <span class="staticText1"
                      *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') || isEscrow">
                {{cardholderPersonalInfo?.address?.country}}
              </span>
              </div>
            </div>
          </div>
          <br>
        </div>
        <!-- Military/Duty address information -->
        <div *ngIf="hasEntitlements('TODO_CARDHOLDERS_PERSONAL_MILITARY_ADDRESS')">
          <div class="borderLine"></div>
          <div class="row">
            <div class="col-md-12 zeroPadding">
              <label for="dutyAddressLine1" class="col-md-12 control-label labelCommon text-nowrap">Military Duty
                Address</label>
              <div class="form-group col-md-12">
                <input placeholder="Address Line 1"
                       *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') && !isEscrow"
                       type="text"
                       class="form-control input-sm"
                       id="dutyAddressLine1"
                       formControlName="dutyAddressLine1"
                       maxlength="34"/>
                <span class="help-block has-error validationMessage"
                      *ngIf="!cardholderPersonalInfoForm.get('dutyAddressLine1').valid &&
                          cardholderPersonalInfoForm.get('dutyAddressLine1').touched">
                <span *ngIf="cardholderPersonalInfoForm.get('dutyAddressLine1').errors?.required">
                   Required
                </span>
                <span *ngIf="cardholderPersonalInfoForm.get('dutyAddressLine1').errors?.maxlength">
                    Address can only be 34 characters
                </span>
              </span>
                <span class="staticText1"
                      *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') || isEscrow">
                {{cardholderPersonalInfo?.dutyAddress?.addressLine1}}
              </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <input placeholder="Address Line 2"
                     *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') && !isEscrow"
                     type="text"
                     class="form-control input-sm"
                     id="dutyAddressLine2"
                     formControlName="dutyAddressLine2"
                     maxlength="34"/>
              <span class="staticText1"
                    *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') || isEscrow">
              {{cardholderPersonalInfo?.dutyAddress?.addressLine2}}
            </span>
            </div>
            <div class="form-group col-md-6">
              <input placeholder="Address Line 3"
                     *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') && !isEscrow"
                     type="text"
                     class="form-control input-sm"
                     id="dutyAddressLine3"
                     formControlName="dutyAddressLine3"
                     maxlength="34"/>
              <span class="staticText1"
                    *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') || isEscrow">
              {{cardholderPersonalInfo.dutyAddress.addressLine3}}
            </span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 zeroPadding">
              <label for="city" class="col-md-12 control-label labelCommon"> City </label>
              <div class="col-md-10">
                <input *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') && !isEscrow"
                       type="text"
                       class="form-control input-sm"
                       id="dutyCity"
                       formControlName="dutyCity"
                       maxlength="34"/>
                <span class="help-block has-error validationMessage"
                      *ngIf="!cardholderPersonalInfoForm.get('dutyCity').valid &&
                          cardholderPersonalInfoForm.get('dutyCity').touched">
                <span *ngIf="cardholderPersonalInfoForm.get('dutyCity').errors['invalidCity']">
                    {{ contactCityErrorMessage }}
                </span>
                <span *ngIf="cardholderPersonalInfoForm.get('dutyCity').errors?.required">
                   Required
                </span>
                <span *ngIf="cardholderPersonalInfoForm.get('dutyCity').errors?.maxlength">
                   City can only be 34 characters
                </span>
              </span>
                <span class="staticText1"
                      *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') || isEscrow">
                {{cardholderPersonalInfo.dutyAddress.city}}
              </span>
              </div>
            </div>
            <div class="col-md-2 zeroPadding" *ngIf="cardholderPersonalInfo">
              <label for="dutyState" class="col-md-12 control-label labelCommon"> State </label>
              <div class="col-md-10">
                <select *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') && !isEscrow"
                        class="form-control input-sm"
                        id="dutyState"
                        formControlName="dutyState">
                  <option *ngFor="let state of cardholderPersonalInfo.states" value="{{state}}">{{state}}</option>
                </select>
                <span class="help-block has-error validationMessage"
                      *ngIf="!cardholderPersonalInfoForm.get('dutyState').valid &&
                          cardholderPersonalInfoForm.get('dutyState').touched">
                <span *ngIf="cardholderPersonalInfoForm.get('dutyState').errors?.required">
                   Required
                </span>
              </span>
                <span class="staticText1"
                      *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') || isEscrow">
                {{cardholderPersonalInfo.dutyAddress.state}}
              </span>
              </div>
            </div>
            <div class="col-md-2 zeroPadding">
              <label for="dutyZip" class="col-md-12 control-label labelCommon"> Zip </label>
              <div class="col-md-10">
                <input *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') && !isEscrow"
                       type="text"
                       class="form-control input-sm"
                       id="dutyZip"
                       formControlName="dutyZip"
                       maxlength="10"/>
                <span class="help-block has-error validationMessage"
                      *ngIf="!cardholderPersonalInfoForm.get('dutyZip').valid &&
                          cardholderPersonalInfoForm.get('dutyZip').touched">
                <span *ngIf="cardholderPersonalInfoForm.get('dutyZip').errors['invalidZip']">
                    {{ contactZipErrorMessage }}
                </span>
                <span *ngIf="cardholderPersonalInfoForm.get('dutyZip').errors?.required">
                   Required
                </span>
                <span *ngIf="cardholderPersonalInfoForm.get('dutyZip').errors?.maxlength">
                   Zip can only be 10 characters
                </span>
              </span>
                <span class="staticText1"
                      *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') || isEscrow">
                {{cardholderPersonalInfo.dutyAddress.zip}}
              </span>
              </div>
            </div>
            <div class="col-md-2 zeroPadding" *ngIf="cardholderPersonalInfo">
              <label for="dutyCountry" class="col-md-12 control-label labelCommon"> Country </label>
              <div class="col-md-10">
                <select *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') && !isEscrow"
                        class="form-control input-sm"
                        id="dutyCountry"
                        formControlName="dutyCountry">
                  <option *ngFor="let country of countries" value="{{country}}">{{country}}</option>
                </select>
                <span class="help-block has-error validationMessage"
                      *ngIf="!cardholderPersonalInfoForm.get('dutyCountry').valid &&
                          cardholderPersonalInfoForm.get('dutyCountry').touched">
                <span *ngIf="cardholderPersonalInfoForm.get('dutyCountry').errors?.required">
                   Required
                </span>
              </span>
                <span class="staticText1"
                      *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_ADDRESS_UPDATE') || isEscrow">
                {{cardholderPersonalInfo.dutyAddress.country}}
              </span>
              </div>
            </div>
          </div>
          <br>
        </div>
        <div *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_SERVICE_STATUS') && cardholderPersonalInfo">
          <div class="borderLine"></div>
          <div class="row">
            <div class="col-md-3 zeroPadding">
              <label for="serviceStatus" class="col-md-12 control-label labelCommon"> Service Status </label>
              <div class="form-group col-md-12">
                <select *ngIf="hasEntitlements('CARDHOLDERS_PERSONAL_INFO_SERVICE_STATUS_UPDATE') && !isEscrow"
                        class="form-control input-sm"
                        id="serviceStatus"
                        formControlName="serviceStatus"
                        [(ngModel)]="cardholderPersonalInfo.nCCustomerAccounts.serviceStatus">
                  <option *ngFor="let status of serviceStatuses" [value]="status"
                          [selected]="status.selected == true">{{status}}</option>
                </select>
                <span class="staticText1"
                      *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_SERVICE_STATUS_UPDATE') || isEscrow">
                {{cardholderPersonalInfo.nCCustomerAccounts?.serviceStatus}}
              </span>
              </div>
            </div>
            <div class="col-md-3 zeroPadding">
              <label for="dateLetterSent" class="col-md-12 control-label labelCommon"> Date Letter Sent </label>
              <div class="form-group col-md-12">
                <div class="input-group datepicker dtpicker-btn">
                  <input
                    id="dateLetterSent"
                    class="form-control"
                    formControlName="dateLetterSent"
                    [readonly]="true"
                    [maxDate]="maxDate"
                    (dateSelect)="reloadSettlementHistory()"
                    (select)="reloadSettlementHistory()"
                    (change)="reloadSettlementHistory()"
                    ngbDatepicker
                    #d1="ngbDatepicker"/>
                  <div class="input-group-append">
                    <button
                      class="fa fa-calendar"
                      (click)="d1.toggle()"
                      type="button">
                    </button>
                  </div>
                </div>
                <span class="staticText1"
                      *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_SERVICE_STATUS_UPDATE') || isEscrow">
                {{cardholderPersonalInfo.nCCustomerAccounts?.dateLetterSent}}
              </span>
              </div>
            </div>
            <div class="col-md-3 zeroPadding">
              <label for="dateLetterReturned" class="col-md-12 control-label labelCommon"> Date Letter Returned </label>
              <div class="form-group col-md-12">
                <div class="input-group datepicker dtpicker-btn">
                  <input
                    id="dateLetterReturned"
                    class="form-control"
                    formControlName="dateLetterReturned"
                    ngbDatepicker
                    [readonly]="true"
                    [maxDate]="maxDate"
                    #d2="ngbDatepicker"/>
                  <div class="input-group-append">
                    <button
                      class="fa fa-calendar"
                      (click)="d2.toggle()"
                      type="button">
                    </button>
                  </div>
                </div>
                <span class="staticText1"
                      *ngIf="!hasEntitlements('CARDHOLDERS_PERSONAL_INFO_SERVICE_STATUS_UPDATE') || isEscrow">
                {{cardholderPersonalInfo.nCCustomerAccounts?.dateLetterSent}}
              </span>
              </div>
            </div>
            <div class="col-md-3 zeroPadding">
              <label class="col-md-12 control-label labelCommon"> Service Status Date </label>
              <div class="form-group col-md-12 staticText1">
                {{cardholderPersonalInfo.nCCustomerAccounts?.serviceStatusDate | date : 'MM/dd/yyyy' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
<app-personal-forms-upload  [profileSearchResult]="cardholder"  (newFormUploaded)="getNewFormSeq()"></app-personal-forms-upload>

